import React, { Component } from "react";

import { Translate } from "react-redux-i18n";

import StatsRow from "./StatsRow";
import Graph from "./Graph";
import Sessions from "./Sessions";

import "../../../styles/components/insights/statistics/InsightsBy.scss";
import graph from "../../../styles/images/graph_grey.svg";
import "../../../styles/utils/_loadingScreen.scss";

class InsightsByCharger extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.fetchInsights();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps?.from !== this.props.from || prevProps?.to !== this.props.to)
      this.props.fetchInsights();
  }

  render() {
    return (
      <div id="insightsByCharger">
        {!this.props.loading ? (
          <>
            <StatsRow type="charger" data={this.props.data} />
            <div id="graph" className="highlight-container">
              <div className="highlight-container-header">
                <img src={graph} alt="" />
                <Translate value="insights_statistics" />
              </div>
              <div className="highlight-container-body">
                <Graph data={this.props.data} from={this.props.from} to={this.props.to} />
              </div>
            </div>
            <Sessions
              mode="charger"
              sessionCount={this.props.data?.sessions || 0}
              from={this.props.from}
              to={this.props.to}
              charger={this.props.charger}
            />
          </>
        ) : (
          <div className="loading-container">
            <div className="loading-spinner">
              <div className="generic-loading">
                <div></div>
                <div></div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default InsightsByCharger;
